<div class="alert alert-info mt-3" role="alert">
  <h5 class="mb-1">{{ 'shared.components.email_placeholder.headline' | translate }}</h5>
  <p class="mb-1 small">{{ 'shared.components.email_placeholder.subline' | translate }}</p>
  <p class="small">{{ 'shared.components.email_placeholder.subline_2' | translate }}</p>

  <hr>

  <ng-container
    [ngTemplateOutlet]="placeholderItemTemplate"
    [ngTemplateOutletContext]="{placeholderType: emailPlaceholders.FIRST_NAME}"
  ></ng-container>
  <ng-container
    [ngTemplateOutlet]="placeholderItemTemplate"
    [ngTemplateOutletContext]="{placeholderType: emailPlaceholders.LAST_NAME}"
  ></ng-container>
  <ng-container
    [ngTemplateOutlet]="placeholderItemTemplate"
    [ngTemplateOutletContext]="{placeholderType: emailPlaceholders.PERSONAL_EMAIL_SIGNATURE}"
  ></ng-container>
  <ng-container
    [ngTemplateOutlet]="placeholderItemTemplate"
    [ngTemplateOutletContext]="{placeholderType: emailPlaceholders.NEW_LINE}"
  ></ng-container>

  <hr>

  <ng-container
    *ngIf="
      emailType === emailTypes.QUOTE ||
      emailType === emailTypes.QUOTE_REMINDER
    "
    [ngTemplateOutlet]="placeholderItemTemplate"
    [ngTemplateOutletContext]="{placeholderType: emailPlaceholders.QUOTE_NUMBER}"
  ></ng-container>

  <ng-container
    *ngIf="
      emailType === emailTypes.QUOTE ||
      emailType === emailTypes.QUOTE_REMINDER
    "
    [ngTemplateOutlet]="placeholderItemTemplate"
    [ngTemplateOutletContext]="{placeholderType: emailPlaceholders.QUOTE_VALIDITY_DATE}"
  ></ng-container>

  <ng-container
    *ngIf="emailType === emailTypes.BOOKING_CONFIRMATION ||
      emailType === emailTypes.REBOOKING_CONFIRMATION ||
      emailType === emailTypes.CANCELLATION_CONFIRMATION ||
      emailType === emailTypes.CANCELLATION_MESSAGE ||
      emailType === emailTypes.TICKET_MESSAGE ||
      emailType === emailTypes.PAY_PER_PAYMENT_LINK"
    [ngTemplateOutlet]="placeholderItemTemplate"
    [ngTemplateOutletContext]="{placeholderType: emailPlaceholders.BOOKING_NUMBER}"
  ></ng-container>

  <ng-container
    *ngIf="templateMode && (
      emailType === emailTypes.BOOKING_CONFIRMATION ||
      emailType === emailTypes.REBOOKING_CONFIRMATION
    )"
    [ngTemplateOutlet]="placeholderItemTemplate"
    [ngTemplateOutletContext]="{placeholderType: emailPlaceholders.BOOKING_EDIT_LINK}"
  ></ng-container>

  <ng-container
    *ngIf="templateMode && (
      emailType === emailTypes.BOOKING_CONFIRMATION ||
      emailType === emailTypes.QUOTE
    )"
    [ngTemplateOutlet]="placeholderItemTemplate"
    [ngTemplateOutletContext]="{placeholderType: emailPlaceholders.BOOKINGS_TABLE}"
  ></ng-container>

  <ng-container
    *ngIf="templateMode && (
      emailType === emailTypes.REBOOKING_CONFIRMATION
    )"
    [ngTemplateOutlet]="placeholderItemTemplate"
    [ngTemplateOutletContext]="{placeholderType: emailPlaceholders.NEW_BOOKINGS_TABLE}"
  ></ng-container>

  <ng-container
    *ngIf="templateMode && (
      emailType === emailTypes.REBOOKING_CONFIRMATION
    )"
    [ngTemplateOutlet]="placeholderItemTemplate"
    [ngTemplateOutletContext]="{placeholderType: emailPlaceholders.OLD_BOOKINGS_TABLE}"
  ></ng-container>

  <ng-container
    *ngIf="templateMode && (
      emailType === emailTypes.CANCELLATION_CONFIRMATION ||
      emailType === emailTypes.CANCELLATION_MESSAGE
    )"
    [ngTemplateOutlet]="placeholderItemTemplate"
    [ngTemplateOutletContext]="{placeholderType: emailPlaceholders.CANCELLED_BOOKINGS_TABLE}"
  ></ng-container>


  <ng-container
    *ngIf="templateMode && (
      emailType === emailTypes.QUOTE ||
      emailType === emailTypes.QUOTE_REMINDER
    )"
    [ngTemplateOutlet]="placeholderItemTemplate"
    [ngTemplateOutletContext]="{placeholderType: emailPlaceholders.CUSTOMER_SERVICE_PROPOSAL_PAYMENT_TYPE}"
  ></ng-container>
</div>

<ng-template #placeholderItemTemplate let-placeholderType="placeholderType">
  <p
    class="pointer"
    (click)="copyPlaceholderToClipboard(placeholderType)"
    title="{{ placeholderType }} {{ 'shared.components.email_placeholder.copy_to_clipboard_hover' | translate }}"
  >
    <b>{{ placeholderType}}</b> - {{ 'enums.emailPlaceholderEnum.' + placeholderType | translate }}
  </p>
</ng-template>
